const buildCreditCardDetailsRequest = (requestData) => {
  const responseNode = {
    cardHolderName: requestData?.cardHolderName,
    paymentMethodNonce: requestData?.transactionNonceData,
    ...(requestData?.requestId && {
      requestId: requestData?.requestId,
    }),
  };
  return responseNode;
};

const buildBankDetailsRequest = (requestData) => {
  const responseNode = {
    bankBSB: requestData?.bankBSB.replace("-", "").trim(),
    bankAccountNumber: requestData?.bankAccountNumber.replace(/\s/g, ""),
    bankAccountName: requestData?.bankAccountName,
    directDebitPermission:
      requestData?.directDebitPermission === "yes" ? true : false,
  };

  return responseNode;
};

const bindPolicyPaymentRequestMapping = async (requestData) => {
  const { paymentMethod, paymentFrequency } = { ...requestData };
  let response = {
    paymentFrequency: paymentFrequency,
    paymentMethod: paymentMethod,
    ...(paymentMethod === "CC" && {
      creditCardDetails: buildCreditCardDetailsRequest(requestData),
    }),
    ...(paymentMethod === "BA" && {
      bankAccountDetails: buildBankDetailsRequest(requestData),
    }),
  };

  return response;
};

export default bindPolicyPaymentRequestMapping;
